export default function BtnLogout(){
    return (
        <svg viewBox="0 0 1102.000000 1102.000000">
            <g transform="translate(0.000000,1102.000000) scale(0.100000,-0.100000)" stroke="none">
                <path d="M5410 11013 c-178 -30 -364 -165 -443 -323 -73 -147 -68 19 -65
                    -2146 l3 -1949 24 -64 c86 -231 299 -392 542 -408 237 -16 467 113 577 324 77
                    149 72 -13 72 2123 0 2103 3 1974 -61 2103 -85 171 -220 280 -407 328 -69 18
                    -177 23 -242 12z"/>
                <path d="M3570 9309 c-445 -235 -780 -478 -1105 -804 -944 -942 -1388 -2264
                    -1204 -3585 226 -1626 1357 -2977 2919 -3489 1222 -400 2578 -224 3660 477
                    549 355 1019 843 1353 1402 786 1318 809 2956 59 4280 -409 723 -1004 1295
                    -1773 1704 -58 31 -111 56 -118 56 -8 0 -11 -182 -11 -703 l0 -703 87 -69
                    c430 -342 787 -849 968 -1376 106 -309 153 -572 162 -905 8 -312 -18 -559 -87
                    -834 -284 -1121 -1174 -1987 -2305 -2241 -194 -44 -344 -61 -591 -66 -254 -6
                    -384 2 -594 38 -844 142 -1599 645 -2066 1376 -250 391 -404 831 -460 1313
                    -20 180 -15 587 10 745 82 512 244 923 524 1324 147 212 389 470 585 626 l87
                    69 0 708 c0 389 -1 708 -2 707 -2 0 -46 -23 -98 -50z"/>
            </g>
        </svg>
    );
}